'use client';

import dynamic from 'next/dynamic';

import type { ListingsPageClientProps } from './listings-page-client';
import { ListingsPageSkeleton } from './listings-page-skeleton';

export const ListingsPageClientDynamic = (
  props: ListingsPageClientProps
) => {
  const ListingsPageClientLazy = dynamic(
    () =>
      import('./listings-page-client').then((m) => ({
        default: m.ListingsPageClient,
      })),
    {
      ssr: false,
      loading: () => (
        <ListingsPageSkeleton
          className={props.className}
          id={props.id}
          showQuickSearch={props.showQuickSearch}
          disableMap={props.disableMap}
          brand={props.brand}
          showWhereInSearch={props.showWhereInSearch}
        />
      ),
    }
  );

  return <ListingsPageClientLazy {...props} />;
};
